import React, { useState, useEffect } from "react";
import Pending from "../../../assets/Icon/pending.png";
import axios from "axios";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const LiveChatPending = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState([]);

  const [buffer, setBuffer] = useState(true);

  // Fetch Pending LiveChat
  useEffect(() => {
    axios.get(`/api/admin/live_chat/pending`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader title="Pending Live Chat" image={Pending} count={count} />

      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`/superstar-admin/live-chat/pending`}
        />
      )}
    </>
  );
};

export default LiveChatPending;
